import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/about-us-image_1.jpg'


const _withScopeId = n => (_pushScopeId("data-v-06defc60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container-fluid px-0 px-md-4 px-lg-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-5" }, [
  /*#__PURE__*/_createTextVNode(" Exceptional Expertise"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-none d-md-block" }),
  /*#__PURE__*/_createTextVNode(" in electrical, networking and"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-none d-md-block" }),
  /*#__PURE__*/_createTextVNode(" related services ")
], -1))
const _hoisted_4 = {
  id: "About",
  class: "py-5 mx-2 mx-md-4 mx-lg-5"
}
const _hoisted_5 = { class: "container-fluid px-0 px-md-4 px-lg-5" }
const _hoisted_6 = { class: "row mb-4 mb-md-5 justify-content-lg--between align-item-center pb-2" }
const _hoisted_7 = { class: "col-lg-6 col-xl-4 order-lg-2 mx-lg-auto" }
const _hoisted_8 = {
  id: "aboutCarousel",
  class: "carousel carousel-dark slide"
}
const _hoisted_9 = { class: "carousel-inner" }
const _hoisted_10 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_11 = { class: "col-10 col-xl-12" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#aboutCarousel\" data-bs-slide=\"prev\" data-v-06defc60><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-06defc60></span><span class=\"visually-hidden\" data-v-06defc60>Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#aboutCarousel\" data-bs-slide=\"next\" data-v-06defc60><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-06defc60></span><span class=\"visually-hidden\" data-v-06defc60>Next</span></button>", 2)
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 my-4 my-lg-0 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center mb-4 mb-md-5" }, " Why Choose Us ", -1))
const _hoisted_18 = { class: "row mb-4 justify-content-between" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "h5 text-primary mt-3" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  id: "Services",
  class: "bg-muted"
}
const _hoisted_23 = { class: "py-5 mx-2 mx-md-4 mx-lg-5" }
const _hoisted_24 = { class: "container-fluid px-0 px-md-4 px-lg-5 my-4 my-md-5" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center mb-4 mb-md-5" }, " Our Services Include ", -1))
const _hoisted_26 = { class: "row g-xl-5 justify-content-center" }
const _hoisted_27 = { class: "text-center service-heading px-2 py-4 d-flex justify-content-center align-items-center" }
const _hoisted_28 = { class: "h4 text-white mb-0" }
const _hoisted_29 = { class: "text-center service-copy bg-white px-2 py-4 d-flex justify-content-center align-items-center" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "col-12 text-center" }
const _hoisted_32 = {
  id: "Testimonials",
  class: "py-5 mx-2 mx-md-4 mx-lg-5"
}
const _hoisted_33 = { class: "container-fluid px-0 px-md-4 px-lg-5 my-4 my-md-5" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center mb-4 mb-md-5" }, " Our Happy Customers ", -1))
const _hoisted_35 = { class: "col-12 d-flex flex-wrap justify-content-center" }
const _hoisted_36 = { class: "col-md-12 col-xl-8 text-center my-4 mx-auto" }
const _hoisted_37 = {
  id: "testimonialsCarousel",
  class: "carousel carousel-dark slide"
}
const _hoisted_38 = { class: "carousel-inner d-flex align-items-center" }
const _hoisted_39 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_40 = { class: "col-10 col-xl-12" }
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#testimonialsCarousel\" data-bs-slide=\"prev\" data-v-06defc60><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-06defc60></span><span class=\"visually-hidden\" data-v-06defc60>Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#testimonialsCarousel\" data-bs-slide=\"next\" data-v-06defc60><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-06defc60></span><span class=\"visually-hidden\" data-v-06defc60>Next</span></button>", 2)
const _hoisted_43 = { class: "row w-100 my-4 d-flex flex-wrap align-items-center justify-content-center" }
const _hoisted_44 = ["src", "alt"]

import { useHead } from "@unhead/vue";
  import GenericBanner from "@/components/banners/GenericBanner.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

  useHead({
    title: "",
    // meta: [
    //   { name: "description", content: "" },
    //   { name: "keywords", content: "", key: "keywords-tag" },
    //   { name: "robots", content: "", key: "robots-tag" }
    // ],
  })

  const AboutCopy = [
    // TODO: once content determined, set a height on .carousel-item based on the height of the slide with the longest content
    // TODO: check and alter heights on different screen sizes if necessary
    {
      title: "Professional. Committed. Hard working.",
      image: "",
      copy: `
        <p>We are a passionate team with a lot of experience in electrical and networking installation. </p>
        <p>Including electrical wiring and installations, Networking and Wi-Fi set ups, call and contact  centre set up, CCTV and IP Camera work. We also have experience in Home automation and smart device setup.</p>
        <p>We have also done many large scale inverter, battery and solar related installations in both residential and commercial settings.</p>
      `,
      button: {
        text: "Our Services",
        link: { hash: '#Services' },
      }
    },
    {
      title: "Tried and trusted!",
      image: "",
      copy: `
        <p>We've been in business for nearly 20 years and our reputation speaks for itself.</p>
        <p>Our clients are mostly based in KwaZulu Natal but we do jobs all around South Africa.</p>
      `,
      button: {
        text: "Our Testimonials",
        link: { hash: '#Testimonials' },
      }
    }
  ]

  const AboutContent = [
    {
      title: "Competitive Rates",
      image: "about-icon_1.png",
      alt: "Competitive Rates",
      copy: ``
    },
    {
      title: "20 Years of Expertise",
      image: "about-icon_2.png",
      alt: "20 Years of Expertise",
      copy: ``
    },
    {
      title: "Exceptional Service",
      image: "about-icon_3.png",
      alt: "Exceptional Service",
      copy: ``
    }
  ]

  const ServicesContent = [
    {
      title: "Electrical and related",
      image: "service-image_1.jpg",
      alt: "",
      copy: `From lighting to compliance and maintenance. We do everything electrical.`
    },
    {
      title: "Networking and CCTV",
      image: "service-image_2.jpg",
      alt: "",
      copy: `We set up networking equipment, including cabling, switching, routing and wi-fi. We also set up IP Cams and CCTV.`
    },
    {
      title: "Home Automation / Smart Devices.",
      image: "service-image_3.jpg",
      alt: "",
      copy: `We have experience in working with the Sonoff range of home automation and smart devices.`
    }
  ]

  const TestimonialContent = [
    {
      quote: `I've worked with Sabelo for more than 10 years, both in my home and business and he has only ever exceeded my expectations. He's reasonably priced, honest and hard working.`,
      person: "Jared Krause: Managing Director, Nologo Studios"
    },
    {
      quote: `I used Sabelo to install some home automation devices, he was excellent and very knowledgable and guided me every step of the way.`,
      person: "Matt Schnell"
    },
    {
      quote: `Sabelo is just amazing. I will continue to use him and recommend him.`,
      person: "Anonymous."
    }
  ]

  const TestimonialLogos = [
    {
      alt: "Nologo Studios Logo",
      image: "nslogo.png"
    },
    {
      alt: "Africa PC Logo",
      image: "africapc_logo.png"
    },
    {
      alt: "Unipower Logo",
      image: "unipower_logo.png"
    }
  ] 

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GenericBanner, {
        id: "IntroBanner",
        class: "py-5",
        image: "/home-banner-image_1.jpg"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_router_link, {
            class: "btn btn-light btn-lg rounded-0 text-uppercase px-4 px-lg-5",
            to: { hash: '#Contact' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contact Us")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(AboutCopy, (about, index) => {
                  return _createElementVNode("div", {
                    class: _normalizeClass(["my-0 my-md-5 carousel-item", {'active': index == 0}]),
                    key: 'about-slide-' + index
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h2", _hoisted_12, _toDisplayString(about.title), 1),
                        _createElementVNode("div", {
                          innerHTML: about.copy,
                          class: "my-4 my-md-5"
                        }, null, 8, _hoisted_13),
                        (about.button.link.hash)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "btn btn-dark btn-lg rounded-0 text-uppercase px-4 px-lg-5",
                              to: about.button.link.hash
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(about.button.text), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 2)
                }), 64))
              ]),
              _hoisted_14
            ])
          ]),
          _hoisted_16
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(AboutContent, (aboutkey, index) => {
            return _createElementVNode("div", {
              class: "col-sm-6 col-md-3 col-xl-2 my-3 my-md-5 text-center",
              key: 'about-copy-' + index
            }, [
              _createElementVNode("img", {
                class: "img-fluid",
                src: require('@/assets/' + aboutkey.image.replace(/^\//g, '')),
                alt: aboutkey.alt
              }, null, 8, _hoisted_19),
              _createElementVNode("h3", _hoisted_20, _toDisplayString(aboutkey.title), 1),
              _createElementVNode("div", {
                innerHTML: aboutkey.copy
              }, null, 8, _hoisted_21)
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ServicesContent, (service, index) => {
              return _createElementVNode("div", {
                class: "col-11 col-sm-8 col-md-6 col-lg-4 my-4",
                key: 'services-' + index
              }, [
                _createElementVNode("div", {
                  class: "service-block d-flex flex-column",
                  style: _normalizeStyle(`background-image:url(${require('@/assets/' + service.image.replace(/^\//g, ''))})`)
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("h3", _hoisted_28, _toDisplayString(service.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", {
                      innerHTML: service.copy
                    }, null, 8, _hoisted_30)
                  ])
                ], 4)
              ])
            }), 64)),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_router_link, {
                class: "btn btn-dark btn-lg rounded-0 text-uppercase px-4 px-lg-5",
                to: { hash: '#Contact' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Contact Us")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TestimonialContent, (testimonial, index) => {
                  return _createElementVNode("div", {
                    class: _normalizeClass(["carousel-item", {'active': index == 0}]),
                    key: 'testimonial-' + index
                  }, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", null, "\"" + _toDisplayString(testimonial.quote) + "\"", 1),
                        _createElementVNode("p", null, _toDisplayString(testimonial.person), 1)
                      ])
                    ])
                  ], 2)
                }), 64))
              ]),
              _hoisted_41
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TestimonialLogos, (testimonial, index) => {
              return _createElementVNode("div", {
                class: "col-12 col-sm-3 text-center my-4 my-sm-2",
                key: 'testimonial-logo-' + index
              }, [
                _createElementVNode("img", {
                  class: "img-fluid",
                  src: require('@/assets/' + testimonial.image.replace(/^\//g, '')),
                  alt: testimonial.alt
                }, null, 8, _hoisted_44)
              ])
            }), 64))
          ])
        ])
      ])
    ])
  ]))
}
}

})